var game;
var world, questions;
var currWorld = 0;
var gameConfig = {};
var video;
const X = 1280/2;
const Y = 720/2;
const WIDTH = 1280;
const HEIGHT = 720;
const aspectRatio = 16/9;
var wayData = null;
var xp = 0;

// Basic Example
function startGame() {
    game = new GameManager({width:1280, height:720});
    initSprites("sprites");
    world = new WorldContainer(worlds[currWorld], {width:1280, height:720, x:X,y:Y, backgroundColor:"blue", clearScreen:true});
    game.add(world);
    questions = new Questions({width:WIDTH, height:HEIGHT, x:X,y:Y, clearScreen:true, visible : false});
    video = new Video();
    $(window).resize(function() {
        doResize(16/9);
    });
    doResize(16/9);
    
    game.states.addState("WORLD", doWorld);
    game.states.addState("VIDEO", doVideo);
    game.states.addState("QUESTIONS", doQuestions);
    game.states.addState("TITLE", doTitle);
    
    game.states.setState("TITLE");
    
    
}

/*
function doResize() {
    var ww = window.innerWidth;
    var hh = window.innerHeight;
    var left = 0,top = 0;
    var cont = $("#container");
    var w = ww;
    var h = ww * 1/aspectRatio;

    if (h>hh) {
        h = hh;
        w = h * aspectRatio;
        left = (ww-w)/2;
    } else {
        top = (hh-h)/2;
    }
    $(cont).width(w).height(h).css({left:left, top:top});

}
*/

/* Using Class Override
class RED extends View {
    constructor(data) {
        super(data);
        this.txt = new Text("Hello World",{color:"yellow", fontSize:20, align:"center", x:this.width/2,y:this.height/2});
        this.add(this.txt);
    }
    update(delta) {
        this.txt.rotation+=(1*delta);
        this.rotation-=(0.5*delta);
    }
}


function startGame() {
    game = new GameManager({width:1280, height:720});
    game.add(new RED({x:1280/2, y:720/2, clearScreen:true, backgroundColor:"red", width:200, height:200}));
}
*/



/*  Using animate and scaled views

class RED extends View {
    constructor(data) {
        super(data);
        this.txt = new Text("Hello World",{color:"yellow", fontSize:20, align:"center", x:this.width/2,y:this.height/2});
        this.add(this.txt);
        this.animate({x:1280,y:720,opacity:0.5},2,this.callback)
    }
    callback(o) {
        var targetX, targetY;
        var targetX = randomInt(0,1280);
        var targetY = randomInt(0,720);
        var scale = randomInt(1,30)/10;
        var opacity = randomInt(2,10)/10;

        o.animate({x:targetX,y:targetY,opacity:opacity, scaleX:scale, scaleY:scale},1,o.callback);
    }

    update(delta) {
        this.txt.rotation+=(1*delta);
        this.rotation-=(0.5*delta);
    }
}


function startGame() {
    game = new GameManager({width:1280, height:720});
    game.add(new RED({x:0, y:720/2, clearScreen:true, backgroundColor:"red", width:200, height:200}));
    game.add(new RED({x:100, y:720/2, clearScreen:true, backgroundColor:"red", width:200, height:200, scaleX:0.3, scaleY:0.3}));
}

*/